import React from 'react';

import estatuto from '../../files/estatuto.pdf';
import pdfIcon from '../../assets/icon_pdf.png';

function Estatuto() {
  return (
    <>
      <h1>Estatuto</h1>
      <p>Confira o nosso estatuto e informe-se sobre seus direitos e deveres.</p>
      <a href={estatuto} target="_blank" rel="noreferrer" className="pdf-button">
        Faça download do estatuto completo
        <img alt="Icone pdf" src={pdfIcon} height="40px" />
      </a>
    </>
  )
}

export default Estatuto;